/* eslint-disable no-loop-func */
import React, { Component } from 'react';

import API from '../../../../utils/API';
import { Modal, ModalBody } from 'reactstrap';

import Dropzone from 'react-dropzone';
import papa from 'papaparse';
import SelectField from '../../../../components/inputs/selectField';
import LoadingWizard from '../../../../components/spinner/wizard';
import { FixedSizeList as List } from 'react-window';

const UNMAPPED_DATA = 'Unmapped Data';

class ImportInventoryClaimsModal extends Component {
    constructor(props) {
        super(props);
        const unmappedData = {};
        unmappedData[UNMAPPED_DATA] = {};

        this.networkControllers = [];
        this.state = {
            files: [],
            customFields: [
                {
                    title: 'Claim Information',
                    _id: 0,
                    fields: [
                        { fieldName: 'Email', fieldType: 'text', _id: 'email' },
                        { fieldName: 'Inventory', fieldType: 'text', _id: 'inventory' },
                        { fieldName: 'Quantity', fieldType: 'number', _id: 'quantity' },
                    ]
                }
            ],
            submitting: false,
            mapping: false,
            mappedData: {},
            unmappedData: unmappedData,
            fieldOptions: [],
            importedClaims: [],
            finished: false,
            importCount: 0,
            importLength: 0,
            emailExists: false,
            inventoryExists: false,
            filteredClaims: [],
            importedStarted: false,
            importError: false,
            errorCount: 0,
            isError: false,
            cancelled: false,
            validating: false,
            invalidEmails: [],
            unavailableInventory: [],
            quantityMismatches: [],
            alreadyClaimed: [],
            duplicateFieldNames: {}
        };
    }

    ValidateEmail(mail) {
        var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (mail.match(mailformat)) {
            return true;
        } else {
            return false;
        }
    }

    componentDidMount() {
        const { duplicateFieldNames, customFields } = this.state;
        customFields.forEach(category => {
            category.fields.forEach(field => {
                const fieldName = field.fieldName;
                if (!duplicateFieldNames[fieldName]) {
                    duplicateFieldNames[fieldName] = 1;
                } else {
                    duplicateFieldNames[fieldName]++;
                }
            });
        });
    }

    downloadCSVTemplate = () => {
        const mappedFieldNames = [];
        this.state.customFields.forEach((category) => {
            category.fields.forEach((field) => {
                mappedFieldNames.push(field.fieldName);
            });
        });
        const csv = papa.unparse([mappedFieldNames]);
        const filename = `InventoryClaimsTemplate.csv`;
        var file = new Blob([csv], { type: 'text/csv' });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, filename);
        } else {
            var a = document.createElement('a'),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    };

    handleImport = () => {
        const { mappedData } = this.state;
        const claims = [];
        
        Object.keys(mappedData).forEach((category) => {
            if (mappedData[category]._id === 0) {
                Object.keys(mappedData[category]).forEach((field) => {
                    if (field !== '_id') {
                        const data = mappedData[category][field];
                        data.forEach((claimData, index) => {
                            if (index > 0) {
                                if (!claims[index]) {
                                    claims[index] = {};
                                }
                                claims[index][data[0].value] = claimData;
                                claims[index]['rowNumber'] = index + 1;
                            }
                        });
                    }
                });
            }
        });

        const filteredClaims = claims.filter((claim) => 
            claim.email && claim.email !== '' && claim.inventory && claim.inventory !== ''
        );

        this.setState(
            {
                submitting: true,
                mapping: false,
                importLength: filteredClaims.length,
                filteredClaims: filteredClaims
            },
            () => {
                this.validateData();
            }
        );
    };

    uploadClaims = async (claims) => {
        const { eventId, orgId, inventory, attendees } = this.props;
        this.setState({ importedStarted: true, submitting: true });
        
        // Group claims by inventory item
        const claimsByInventory = {};
        claims.forEach(claim => {
            const inventoryItem = inventory.find(i => 
                i.name && i.name.toLowerCase() === claim.inventory.toLowerCase()
            );
            if (inventoryItem) {
                if (!claimsByInventory[inventoryItem._id]) {
                    claimsByInventory[inventoryItem._id] = {
                        inventoryId: inventoryItem._id,
                        inventoryName: inventoryItem.name,
                        attendees: []
                    };
                }
                const attendee = attendees.find(a => 
                    a.email && a.email.toLowerCase() === claim.email.toLowerCase()
                );
                if (attendee) {
                    claimsByInventory[inventoryItem._id].attendees.push({
                        _id: attendee._id,
                        email: attendee.email,
                        firstName: attendee.firstName,
                        lastName: attendee.lastName
                    });
                }
            }
        });

        // Process inventory items in parallel batches
        const inventoryIds = Object.keys(claimsByInventory);
        const batchSize = 5; // Process 5 inventory items at a time
        const batches = [];
        
        for (let i = 0; i < inventoryIds.length; i += batchSize) {
            batches.push(inventoryIds.slice(i, i + batchSize));
        }

        for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
            if (this.state.cancelled) break;
            
            const batch = batches[batchIndex];
            
            // Process this batch in parallel
            await Promise.all(batch.map(async (inventoryId) => {
                const claimGroup = claimsByInventory[inventoryId];
                const attendeeIds = claimGroup.attendees.map(a => a._id);

                const networkController = new AbortController();
                this.networkControllers.push(networkController);

                return API()
                    .patch(`Organizations/${orgId}/events/${eventId}/batchInventoryPatch`, {
                        inventoryIds: [inventoryId],
                        redeemedBy: attendeeIds,
                    }, { signal: networkController.signal })
                    .then((res) => {
                        const { importedClaims } = this.state;
                        if (res.data) {
                            // Add success entries for each attendee
                            claimGroup.attendees.forEach(attendee => {
                                importedClaims.push({
                                    success: true,
                                    email: attendee.email,
                                    inventoryName: claimGroup.inventoryName
                                });
                            });
                            
                            this.setState({
                                importCount: importedClaims.length,
                                importedClaims: importedClaims
                            });
                            
                            // Update local inventory state
                            if (this.props.updateInventory && res.data.length > 0) {
                                res.data.forEach(updatedItem => {
                                    this.props.updateInventory(updatedItem);
                                });
                            }
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        const { importedClaims } = this.state;
                        // Add error entries for each attendee in this group
                        claimGroup.attendees.forEach(attendee => {
                            importedClaims.push({
                                success: false,
                                email: attendee.email,
                                inventoryName: claimGroup.inventoryName,
                                error: e.message === "Canceled" ? e.message :
                                    e.response && e.response.data.message
                                        ? e.response.data.message
                                        : 'Failed to assign inventory'
                            });
                        });
                        this.setState({ 
                            importedClaims: importedClaims, 
                            errorCount: this.state.errorCount + claimGroup.attendees.length
                        });
                    });
            }));
        }

        this.setState({ finished: true });
    };

    validateData = async () => {
        const { mappedData, filteredClaims } = this.state;
        const { inventory, attendees } = this.props;
        
        let invalidEmails = [];
        let unavailableInventory = [];
        let quantityMismatches = [];
        let emailExists = false;
        let inventoryExists = false;
        let alreadyClaimed = [];
        
        this.setState({ validating: true });

        if (mappedData['Claim Information']) {
            if (mappedData['Claim Information']['Email']) {
                emailExists = true;
                
                // Validate emails
                mappedData['Claim Information']['Email'].forEach((email, index) => {
                    if (index > 0 && email) {
                        const emailLower = email.toLowerCase();
                        if (!this.ValidateEmail(emailLower)) {
                            invalidEmails.push({ 
                                rowNumber: index + 1, 
                                email: email 
                            });
                        } else {
                            // Check if attendee exists
                            const attendeeExists = attendees.some(a => 
                                a.email && a.email.toLowerCase() === emailLower
                            );
                            if (!attendeeExists) {
                                invalidEmails.push({ 
                                    rowNumber: index + 1, 
                                    email: email,
                                    error: 'Attendee not found'
                                });
                            }
                        }
                    }
                });
            }

            if (mappedData['Claim Information']['Inventory']) {
                inventoryExists = true;
                
                // Validate inventory availability
                mappedData['Claim Information']['Inventory'].forEach((invName, index) => {
                    if (index > 0 && invName) {
                        const inventoryItem = inventory.find(i => 
                            i.name && i.name.toLowerCase() === invName.toLowerCase()
                        );
                        
                        if (!inventoryItem) {
                            unavailableInventory.push({ 
                                rowNumber: index + 1, 
                                inventoryName: invName,
                                error: 'Inventory item not found'
                            });
                        } else {
                            const email = mappedData['Claim Information']['Email']
                                ? mappedData['Claim Information']['Email'][index]
                                : null;
                            if(email){
                                const emailLower = email.toLowerCase();
                                const attendee = attendees.find(a => a.email && a.email.toLowerCase() === emailLower);
                                if (attendee && inventoryItem.redeemedBy && inventoryItem.redeemedBy.some(rid => rid.toString() === attendee._id.toString())) {
                                    // Already claimed by this attendee — skip this row (do not treat as an error)
                                    alreadyClaimed.push({
                                        rowNumber: index + 1,
                                        inventoryName: invName,
                                        email: email,
                                        attendeeName: `${attendee.firstName || ''} ${attendee.lastName || ''}`.trim()
                                    });
                                    return; // skip quantity check for this row
                                }
                                
                            }
                            const quantity = mappedData['Claim Information']['Quantity'] 
                                ? mappedData['Claim Information']['Quantity'][index] 
                                : 1;
                            
                            if (quantity && inventoryItem.quantity) {
                                const redeemedCount = inventoryItem.redeemedBy ? inventoryItem.redeemedBy.length : 0;
                                const available = inventoryItem.quantity - redeemedCount;
                                
                                if (quantity > available) {
                                    quantityMismatches.push({ 
                                        rowNumber: index + 1, 
                                        inventoryName: invName,
                                        requested: quantity,
                                        available: available
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }

        // Filter out invalid claims
        let validClaims = filteredClaims.filter(claim => {
            const hasInvalidEmail = invalidEmails.some(ie => 
                ie.email.toLowerCase() === claim.email.toLowerCase()
            );
            const hasUnavailableInventory = unavailableInventory.some(ui => 
                ui.inventoryName.toLowerCase() === claim.inventory.toLowerCase()
            );
            const hasQuantityMismatch = quantityMismatches.some(qm => 
                qm.inventoryName.toLowerCase() === claim.inventory.toLowerCase()
            );
            const hasAlreadyClaimed = alreadyClaimed.some(ac =>
                ac.email.toLowerCase() === claim.email.toLowerCase() &&
                ac.inventoryName.toLowerCase() === claim.inventory.toLowerCase()
            );
            
            return !hasInvalidEmail && !hasUnavailableInventory && !hasQuantityMismatch && !hasAlreadyClaimed;
        });

        let isError = !emailExists || !inventoryExists || 
                    invalidEmails.length > 0 || 
                    unavailableInventory.length > 0 || 
                    quantityMismatches.length > 0;

        this.setState({
            emailExists: emailExists,
            inventoryExists: inventoryExists,
            invalidEmails: invalidEmails,
            unavailableInventory: unavailableInventory,
            quantityMismatches: quantityMismatches,
            filteredClaims: validClaims,
            importLength: validClaims.length,
            alreadyClaimed: alreadyClaimed,
            submitting: false,
            validating: false,
            isError: isError
        }, () => {
            if (!isError) {
                this.uploadClaims(this.state.filteredClaims);
            }
        });
    };

    isRequiredMapped = () => {
        const { mappedData } = this.state;
        if (mappedData['Claim Information']) {
            if (!mappedData['Claim Information']['Email']) {
                this.setState({ emailExists: false });
            } else {
                this.setState({ emailExists: true });
            }
            if (!mappedData['Claim Information']['Inventory']) {
                this.setState({ inventoryExists: false });
            } else {
                this.setState({ inventoryExists: true });
            }
        }
    };

    onDrop = (files) => {
        if (!files || files.length === 0) {
            console.log('onDrop called without files:', files);
            return;
        }
        papa.parse(files[0], {
            complete: (res) => {
                try {
                    const trimmedData = res.data.filter(subArray => {
                        let isEmptyRow = true;
                        subArray.forEach(data => {
                            if (data.trim() !== '') {
                                isEmptyRow = false;
                            }
                        });
                        return !isEmptyRow;
                    });

                    const data = this.mapData(trimmedData);
                    const mappedData = data.mappedData;
                    const unmappedData = data.unmappedData;
                    const fieldData = this.state.customFields.map((category) => {
                        const title = category.title;
                        const headers = category.fields.map((header) => {
                            const name = header.fieldName;
                            return {
                                _id: header._id,
                                category: title,
                                categoryId: category._id,
                                value: name,
                                label: name
                            };
                        });
                        return {
                            label: title,
                            value: category._id,
                            options: headers
                        };
                    });
                    this.isRequiredMapped();
                    
                    this.setState({
                        mapping: true,
                        mappedData: mappedData,
                        unmappedData: unmappedData,
                        fieldOptions: fieldData
                    });
                } catch (e) {
                    console.log(e);
                    this.setState({ importError: true });
                }
            }
        });
        this.setState({
            files
        });
    };

    mapData = (csvData) => {
        const { customFields, duplicateFieldNames } = this.state;
        const csvHeaders = csvData[0];
        const mappedData = {};
        let usedFields = [];
        
        customFields.forEach((category) => {
            const categoryTitle = category.title;
            mappedData[categoryTitle] = {};
            mappedData[categoryTitle]._id = category._id;
            category.fields.forEach((field) => {
                let fieldName = field.fieldName;
                if (!usedFields.includes(fieldName)) {
                    mappedData[categoryTitle][fieldName] = [{ label: fieldName, value: field._id }];

                    let count = -1;
                    const headerIndex = csvHeaders.findIndex((csvHeader) => {
                        count++;
                        if (csvHeader.toLowerCase() === fieldName.toLowerCase()) {
                            if (duplicateFieldNames && duplicateFieldNames[fieldName] > 1) {
                                return false;
                            }
                            if (!usedFields.find((o) => o.fieldName === fieldName && o.index === count)) {
                                usedFields.push({ fieldName: fieldName, index: count });
                                return true;
                            }
                        }
                        return false;
                    });
                    
                    if (headerIndex > -1) {
                        mappedData[categoryTitle][fieldName][0].headerIndex = headerIndex;
                        csvData.forEach((row, index) => {
                            if (index > 0) {
                                if (!mappedData[categoryTitle][fieldName][index]) {
                                    mappedData[categoryTitle][fieldName][index] = [];
                                }
                                let value = null;
                                switch (field.fieldType) {
                                    case 'number':
                                        value = row[headerIndex] ? Number.parseInt(row[headerIndex]) : 1;
                                        break;
                                    default:
                                        value = row[headerIndex];
                                }
                                mappedData[categoryTitle][fieldName][index] =
                                    typeof value == 'string' ? value.trim() : value;
                            }
                        });
                    }
                    if (mappedData[categoryTitle][fieldName].length < 2) {
                        delete mappedData[categoryTitle][fieldName];
                    }
                }
            });
            if (Object.keys(mappedData[categoryTitle]).length < 2) {
                delete mappedData[categoryTitle];
            }
        });

        const unmappedData = {};
        unmappedData[UNMAPPED_DATA] = {};
        csvHeaders.forEach((header, headerIndex) => {
            if (!usedFields.find((f) => f.fieldName === header && f.index === headerIndex)) {
                unmappedData[UNMAPPED_DATA][header.concat('-', headerIndex.toString())] = [
                    {
                        label: header,
                        value: header,
                        headerIndex: headerIndex
                    }
                ];
                csvData.forEach((row, index) => {
                    if (index > 0) {
                        unmappedData[UNMAPPED_DATA][header.concat('-', headerIndex.toString())][index] =
                            row[headerIndex];
                    }
                });
            }
        });
        
        if (mappedData['Claim Information']) {
            this.setState({
                emailExists: Object.keys(mappedData['Claim Information']).includes('Email'),
                inventoryExists: Object.keys(mappedData['Claim Information']).includes('Inventory'),
            });
        } else {
            this.setState({ emailExists: false, inventoryExists: false });
        }

        return { mappedData, unmappedData };
    };

    FieldContainer = (category, header, columnData, index, size, isUnmapped) => {
        const selectedOption = {
            value: header,
            label: header
        };

        const dataPreview = JSON.parse(JSON.stringify(columnData));
        let data = '';
        for (let dataCount = 1; dataCount < dataPreview.length; dataCount++) {
            let current = dataPreview[dataCount];
            if (current) {
                data = current;
                break;
            }
        }
        
        return (
            <div className="w-100 mb-20" key={index}>
                <div className='flex aic jcsb'>
                    <div className='flex w-100'>
                        <div className='' style={{ width: 21 }}>
                        </div>

                        <div
                            className='w-100'
                            style={{
                                maxWidth: 283,
                                minWidth: 283,
                                width: 283,
                                border: isUnmapped ? `1px solid var(--danger)` : `1px solid var(--border)`,
                                borderRadius: 5,
                                padding: '3px 17px',
                                height: 40
                            }}>
                            <p>{columnData[0].label}</p>
                            <p style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                                className='small grey'>Ex: {data ? data : 'Blank column'}</p>
                        </div>
                    </div>
                    <i className="las la-arrow-right mr-5 ml-5"
                        style={{
                            color: category !== UNMAPPED_DATA ? 'var(--primary)' : '',
                        }}
                    />
                    <div className="w-100 mb-a">
                        <SelectField
                            label=""
                            style={{
                                maxWidth: 283,
                                minWidth: 283,
                                width: 283
                            }}
                            classes=" neu mb-0 "
                            value={category !== UNMAPPED_DATA && selectedOption}
                            options={this.state.fieldOptions}
                            onChange={(data) => {
                                if (category !== UNMAPPED_DATA) {
                                    const mappedData = this.state.mappedData;
                                    columnData[0] = { label: data.label, value: data._id };
                                    if (!mappedData[data.category]) {
                                        mappedData[data.category] = [];
                                        mappedData[data.category][data.label] = columnData;
                                        delete mappedData[category][header];
                                    } else if (!mappedData[data.category][data.label]) {
                                        mappedData[data.category][data.label] = columnData;
                                        delete mappedData[category][header];
                                    }
                                    this.setState({ mappedData: mappedData }, () => this.isRequiredMapped());
                                } else {
                                    const mappedData = this.state.mappedData;
                                    const unmappedData = this.state.unmappedData;
                                    columnData[0] = { label: columnData[0].label, value: data._id };
                                    if (!mappedData[data.category]) {
                                        mappedData[data.category] = {};
                                        mappedData[data.category]._id = data.categoryId;
                                        mappedData[data.category][data.label] = columnData;
                                        delete unmappedData[category][header];
                                    } else if (!mappedData[data.category][data.label]) {
                                        mappedData[data.category][data.label] = columnData;
                                        delete unmappedData[category][header];
                                    }

                                    this.setState({ mappedData: mappedData, unmappedData: unmappedData }, () =>
                                        this.isRequiredMapped()
                                    );
                                }
                            }}
                            additionalSelectElement={
                                category !== UNMAPPED_DATA ? (
                                    <div
                                        className='c-pointer'
                                        style={{
                                            position: 'absolute',
                                            zIndex: 999,
                                            right: 30,
                                            top: 10
                                        }}
                                        onClick={() => {
                                            const mappedData = this.state.mappedData;
                                            const unmappedData = this.state.unmappedData;
                                            const propertyName = columnData[0].label.concat('-', columnData[0].headerIndex);
                                            if (!unmappedData[UNMAPPED_DATA]) {
                                                unmappedData[UNMAPPED_DATA] = [];
                                                delete mappedData[category][header];
                                                unmappedData[UNMAPPED_DATA][propertyName] = columnData;
                                            } else if (!unmappedData[UNMAPPED_DATA][propertyName]) {
                                                delete mappedData[category][header];
                                                unmappedData[UNMAPPED_DATA][propertyName] = columnData;
                                            } else if (unmappedData[UNMAPPED_DATA][propertyName]) {
                                                delete mappedData[category][header];
                                            }
                                            if (Object.keys(mappedData[category]).length < 2) {
                                                delete mappedData[category];
                                            }
                                            this.setState({ mappedData: mappedData, unmappedData: unmappedData }, () => {
                                                this.isRequiredMapped();
                                            });
                                        }}
                                    >
                                        <i className="lar la-times-circle grey"></i>
                                    </div>
                                ) : null
                            }
                        />
                    </div>
                </div>
            </div>
        );
    };

    skipInvalidEmail = (email) => {
        const { invalidEmails } = this.state;
        const removed = invalidEmails.filter((e) => e.email !== email);
        this.setState({ invalidEmails: removed });
    };

    skipUnavailableInventory = (inventoryName) => {
        const { unavailableInventory } = this.state;
        const removed = unavailableInventory.filter((i) => i.inventoryName !== inventoryName);
        this.setState({ unavailableInventory: removed });
    };

    skipQuantityMismatch = (inventoryName) => {
        const { quantityMismatches } = this.state;
        const removed = quantityMismatches.filter((q) => q.inventoryName !== inventoryName);
        this.setState({ quantityMismatches: removed });
    };

    cancelImport = async () => {
        this.setState({ cancelled: true });
        this.networkControllers.forEach(async (controller) => {
            try {
                controller.abort();
            } catch (e) {
                console.log(e);
            }
        });
    };

    render() {
        const { isOpen, toggle } = this.props;
        const {
            submitting,
            mapping,
            mappedData,
            unmappedData,
            finished,
            cancelled,
            importLength,
            importedClaims,
            emailExists,
            inventoryExists,
            importedStarted,
            isError,
            invalidEmails,
            unavailableInventory,
            quantityMismatches,
            alreadyClaimed,
        } = this.state;
        
        const hasUnmappedData = Object.keys(unmappedData[UNMAPPED_DATA]).length > 0;
        let index = 0;
        let isButtonDisabled = !emailExists || !inventoryExists || importedStarted ||
            (isError && (invalidEmails.length > 0 || unavailableInventory.length > 0 || quantityMismatches.length > 0));

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="import importModal">
                <div className="modalHeader pb-0">
                    <button onClick={toggle} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}>
                        <i className='las la-times'></i>
                    </button>
                    <div className="headerContainer">
                        <h1>Import Inventory Claims</h1>
                    </div>
                </div>

                <ModalBody className="modalBody">
                    {!importedStarted && mapping ? (
                        <div className={`sectionBody w-100 anim left`}
                            style={{
                                maxHeight: 400
                            }}
                        >
                            <div className='mb-20'>
                                <h4 className='mb-10'>Map your CSV columns to assign inventory to attendees.</h4>
                            </div>
                            <div className='scrollContainer'>
                                {(!emailExists || !inventoryExists) && (
                                    <p style={{ color: 'red' }}>
                                        {!emailExists && 'Email is required. '}
                                        {!inventoryExists && 'Inventory is required. '}
                                        Please map the missing field(s).
                                    </p>
                                )}
                                {hasUnmappedData &&
                                    <div>
                                        <div className='flex mb-10'>
                                            <h3 style={{ width: '50%' }}>Unmapped Data</h3>
                                            <h3 className='ml-25' style={{ width: '50%' }}>Claim Column</h3>
                                        </div>
                                    </div>}
                                {hasUnmappedData && (<div className="importedDataRow">
                                    {Object.keys(unmappedData[UNMAPPED_DATA]).map((dataKey) =>
                                        this.FieldContainer(
                                            UNMAPPED_DATA,
                                            dataKey,
                                            unmappedData[UNMAPPED_DATA][dataKey],
                                            index++,
                                            true,
                                            true
                                        )
                                    )}
                                </div>
                                )}

                                {Object.keys(mappedData).map((key) => {
                                    if (key !== '_id') {
                                        const categoryData = mappedData[key];
                                        return (
                                            <div key={key}>
                                                <div>
                                                    <div className='flex mb-10'>
                                                        <h3 style={{ marginLeft: '20px', width: '50%' }}>{key}</h3>
                                                        <h3 className='ml-25' style={{ width: '50%' }}>Claim Data</h3>
                                                    </div>
                                                </div>
                                                <div className="importedDataRow">
                                                    {Object.keys(categoryData).map(
                                                        (dataKey) =>
                                                            dataKey !== '_id' &&
                                                            this.FieldContainer(
                                                                key,
                                                                dataKey,
                                                                categoryData[dataKey],
                                                                index++,
                                                                hasUnmappedData
                                                            )
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                    ) : !importedStarted && isError ? (
                        <div className={`sectionBody w-100 anim left ml-10`}>
                            {!isButtonDisabled ? <div className='text-c mb-40 mt-20'>
                                {importLength > 0 ? <h3 className='mb-10'>All Errors Resolved</h3> : <h3 className='mb-10'>No Data to Import</h3>}
                                {importLength > 0 ? <p className='mb-10'>You may begin to import your data.</p> : <p className='mb-10'>There is no data to be imported.</p>}
                            </div> : <div className='text-c mb-40 mt-20'>
                                <h3 className='mb-10'>Errors found in data</h3>
                                <p className='mb-10'>
                                    Please review and make the necessary changes to continue importing.
                                </p>
                            </div>}

                            {invalidEmails.length > 0 && (
                                <div className="sectionBlock m-a">
                                    <h3>Invalid or Missing Attendees</h3>
                                    <p className='mb-10'>
                                        These emails are invalid or attendees don't exist in the system.
                                    </p>
                                    <div className="sectionTable mb-20" style={{ maxHeight: 300 }}>
                                        <div className="tableSubColumns" style={{ overflow: 'hidden' }}>
                                            <div className="tableColumnHeader">
                                                <div style={{ width: 50 }}>
                                                    <h3>Row #</h3>
                                                </div>
                                                <div className="tableSubColumnNoSort">
                                                    <div className="tableCellData">
                                                        <h3>Email</h3>
                                                    </div>
                                                </div>
                                                <div className="tableSubColumnNoSort">
                                                    <div className="tableCellData">
                                                        <h3>Error</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tableColumnRows w-fc">
                                                {invalidEmails.map((o) => {
                                                    return (
                                                        <div key={index} className="tableColumnRow" style={{ borderBottom: 'none' }}>
                                                            <div style={{ width: 50 }}>{o.rowNumber}</div>
                                                            <div className="tableColumnRowCell text-truncate">{o.email}</div>
                                                            <div className="tableColumnRowCell text-truncate">{o.error || 'Invalid format'}</div>
                                                            <button
                                                                onClick={() => {
                                                                    this.skipInvalidEmail(o.email);
                                                                }}
                                                                className="neu min"
                                                            >
                                                                Skip
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {unavailableInventory.length > 0 && (
                                <div className="sectionBlock m-a mt-20">
                                    <h3>Unavailable Inventory</h3>
                                    <p className='mb-10'>
                                        These inventory items were not found in the system.
                                    </p>
                                    <div className="sectionTable mb-20" style={{ maxHeight: 300 }}>
                                        <div className="tableSubColumns" style={{ overflow: 'hidden' }}>
                                            <div className="tableColumnHeader">
                                                <div style={{ width: 50 }}>
                                                    <h3>Row #</h3>
                                                </div>
                                                <div className="tableSubColumnNoSort">
                                                    <div className="tableCellData">
                                                        <h3>Inventory Name</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tableColumnRows w-fc">
                                                {unavailableInventory.map((o) => {
                                                    return (
                                                        <div key={index} className="tableColumnRow" style={{ borderBottom: 'none' }}>
                                                            <div style={{ width: 50 }}>{o.rowNumber}</div>
                                                            <div className="tableColumnRowCell text-truncate">{o.inventoryName}</div>
                                                            <button
                                                                onClick={() => {
                                                                    this.skipUnavailableInventory(o.inventoryName);
                                                                }}
                                                                className="neu min"
                                                            >
                                                                Skip
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {quantityMismatches.length > 0 && (
                                <div className="sectionBlock m-a mt-20">
                                    <h3>Quantity Mismatches</h3>
                                    <p className='mb-10'>
                                        Requested quantities exceed available inventory.
                                    </p>
                                    <div className="sectionTable mb-20" style={{ maxHeight: 300 }}>
                                        <div className="tableSubColumns" style={{ overflow: 'hidden' }}>
                                            <div className="tableColumnHeader">
                                                <div style={{ width: 50 }}>
                                                    <h3>Row #</h3>
                                                </div>
                                                <div className="tableSubColumnNoSort">
                                                    <div className="tableCellData">
                                                        <h3>Inventory</h3>
                                                    </div>
                                                </div>
                                                <div className="tableSubColumnNoSort">
                                                    <div className="tableCellData">
                                                        <h3>Requested</h3>
                                                    </div>
                                                </div>
                                                <div className="tableSubColumnNoSort">
                                                    <div className="tableCellData">
                                                        <h3>Available</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tableColumnRows w-fc">
                                                {quantityMismatches.map((o) => {
                                                    return (
                                                        <div key={index} className="tableColumnRow" style={{ borderBottom: 'none' }}>
                                                            <div style={{ width: 50 }}>{o.rowNumber}</div>
                                                            <div className="tableColumnRowCell text-truncate">{o.inventoryName}</div>
                                                            <div className="tableColumnRowCell">{o.requested}</div>
                                                            <div className="tableColumnRowCell">{o.available}</div>
                                                            <button
                                                                onClick={() => {
                                                                    this.skipQuantityMismatch(o.inventoryName);
                                                                }}
                                                                className="neu min"
                                                            >
                                                                Skip
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={`sectionBody w-100 anim left`}>
                            {!importedStarted && !submitting ? (
                                <div>
                                    {!this.state.validating ? <div className='flex flex-wrap column w-100'>
                                        <div className='mb-20'>
                                            <h4 className='mb-10'>Import inventory claims from a CSV file to assign inventory to attendees.</h4>
                                        </div>

                                        <Dropzone
                                            accept="text/csv"
                                            className="clickable dropzone-details banner mb-10"
                                            style={{ height: 375 }}
                                            onDrop={this.onDrop.bind(this)}
                                        >
                                            <div>
                                                <div className="addIcon">
                                                    <i className="las la-plus"></i>
                                                </div>
                                                <p className='text-c'>
                                                    Add inventory claims CSV File<br />
                                                    or <span style={{ color: '#2B83F1' }}>Browse</span>
                                                </p>
                                            </div>
                                        </Dropzone>

                                        <div className='mb-40 mt-40 mt-20'>
                                            <h3>Need help getting started?</h3>
                                            <p>CSV must contain Email, Inventory name, and optionally Quantity columns</p>
                                            <p>
                                                <span className='click seBlue c-pointer' onClick={this.downloadCSVTemplate}>Download</span> a sample CSV file
                                            </p>
                                        </div>
                                    </div>
                                        : <LoadingWizard text="Validating" loading={true} />}
                                </div>
                            ) : importedStarted ? (
                                <div className="flex column aic pt-20 h-100">
                                    <h2>
                                        {cancelled ? 'Import Stopped' :
                                            finished ? 'Importing Complete' :
                                                importedStarted && 'Importing Claims...'}
                                    </h2>
                                    {importedStarted && (
                                        <p className="mb-20">
                                            {(importedClaims.length - this.state.errorCount)} of {importLength} claim{importLength === 1 ? '' : 's'} imported
                                        </p>
                                    )}

                                    <div className='sectionBlockAttendees'>
                                        <div className='sectionBlock'>
                                            {alreadyClaimed && alreadyClaimed.length > 0 && (
                                                <div className='sectionBlock mt-20'>
                                                    <h3 className="pt-20">Limit Reached </h3>
                                                    <List
                                                        height={Math.min(200, alreadyClaimed.length * 40)}
                                                        itemCount={alreadyClaimed.length}
                                                        itemSize={40}
                                                        width={"100%"}
                                                    >
                                                        {({ index, style }) => {
                                                            const ac = alreadyClaimed[index];
                                                            return (
                                                                <div className="importRow" style={style} key={index}>
                                                                    <div className='w-100'
                                                                        style={{
                                                                            maxWidth: '60%',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                        }}>{ac.email} - {ac.inventoryName}</div>
                                                                    <div className="statusContainer">
                                                                        {'Claimed'}
                                                                        <i className="las la-check-circle green" />
                                                                    </div>
                                                                </div>
                                                            );
                                                        }}
                                                    </List>
                                                </div>
                                            )}
                                            <h3 className="pt-20">Imported Claims</h3>
                                            <List
                                                height={400}
                                                itemCount={importedClaims.length}
                                                itemSize={40}
                                                width={"100%"}
                                            >
                                                {({ index, style }) => {
                                                    const claim = importedClaims[index];
                                                    return (
                                                        <div className="importRow" style={style} key={index}>
                                                            <div className='w-100'
                                                                style={{
                                                                    maxWidth: '50%',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                }}>{claim.email} - {claim.inventoryName || claim.inventory}</div>
                                                            <div className="statusContainer">
                                                                {claim.success ? 'Imported' : claim.error}
                                                                {claim.success ? (
                                                                    <i className="las la-check-circle green" />
                                                                ) : (
                                                                    <i className="las la-times-circle red" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                }}
                                            </List>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )}
                </ModalBody>
                <div className={`flex mt-20 ${importedStarted ? 'mt-20' : ''}`}>
                    <button
                        onClick={submitting && !finished ? this.cancelImport : this.props.toggle}
                        outline
                        className={`neu ml-a mr-15`}
                    >
                        {finished ? 'Close' : 'Cancel'}
                    </button>

                    {!finished && (!isError || importLength > 0) && <button
                        className={`neu ${isButtonDisabled ? 'disabled' : 'prim'}`}
                        onClick={() => {
                            if (isError) {
                                if (invalidEmails.length === 0 && unavailableInventory.length === 0 && quantityMismatches.length === 0) {
                                    this.uploadClaims(this.state.filteredClaims);
                                }
                            } else {
                                this.handleImport();
                            }
                        }}
                    >
                        {(!submitting) && importedClaims.length === 0 ? (
                            'Import'
                        ) : cancelled ? (
                            'Cancelling...'
                        ) : (
                            'Importing Claims...'
                        )}
                    </button>}
                </div>
            </Modal>
        );
    }
}

export default ImportInventoryClaimsModal;
